import React from 'react';

import { ArrowForwardIconGray } from '../customicons/ArrowForwardIconGray';


import './cardwithoutimage.css'

export const CardWithoutImage = ({header, text, onClick}) => {

  const styles = {
    container: {
      alignItems: 'center', // Center vertically
  
      padding: '10px',
      width: '100%',
      border:'none',
    
      cursor: 'pointer',
     // backgroundColor: 'rgb(169, 191, 204)',
      backgroundColor: 'rgb(244, 235, 217)',
      
    },
    header: {
      fontSize:'22px',
      fontWeight:'500', 
      color: 'maroon',
      marginBottom: '10px',
    },
    text: {
      marginRight: '20px', // Optional spacing after the text
    },
   
    }

  return (
    <div>

          <div  className='imageText cardContainer' onClick = {onClick}>
         
            <label style={styles.header}>{header}</label>
            <br></br>
          
            {text}    
          
            <ArrowForwardIconGray onClick = {onClick} />
          </div>
    </div>
  );
};

